import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40d9cc34&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=40d9cc34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9cc34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d9cc34')) {
      api.createRecord('40d9cc34', component.options)
    } else {
      api.reload('40d9cc34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40d9cc34&scoped=true", function () {
      api.rerender('40d9cc34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopee-order/index.vue"
export default component.exports